import { formatDateInZone } from "@nurion/datetime/format-date-in-zone";

export const LOCAL_ZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export function absoluteFallback(ts: number): string {
  return formatDateInZone(new Date(ts).toISOString(), LOCAL_ZONE, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function formatUntil(date: Date): string {
  return formatDateInZone(date.toISOString(), LOCAL_ZONE, { hour: "2-digit", minute: "2-digit" });
}

const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

export function formatRelativeAgo(ts: number, now: number = Date.now()): string {
  const diff = now - ts;
  if (diff < MINUTE_MS) return "just now";
  if (diff < HOUR_MS) return `${Math.max(1, Math.floor(diff / MINUTE_MS))}m ago`;
  if (diff < DAY_MS) return `${Math.max(1, Math.floor(diff / HOUR_MS))}h ago`;
  const days = Math.floor(diff / DAY_MS);
  if (diff < 30 * DAY_MS) return `${days} day${days === 1 ? "" : "s"} ago`;
  return absoluteFallback(ts);
}
